import React, { Component } from 'react';
import classNames from 'classnames';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Boolean} [checked]
 *
 * @augments {Component<Props>}
 */
export default class CheckElement extends Component {
	genWrapClassName = (props) =>
		classNames('CheckElement', { Checked: props.checked });

	genTickClassName = (props) =>
		classNames({ Clear: !props.checked, Tick: props.checked });

	render () {
		return (<div className={this.genWrapClassName(this.props)}>
			<div className={this.genTickClassName(this.props)} />
		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/CheckElement/CheckElement.js